import UserActivityService from "../services/userActivity";

export const CLEAR_TIMER = "CLEAR_TIMER";
export const SET_TIMER_USER_ID = "SET_TIMER_USER_ID";
export const SET_TIMER_CUSTOM_APP_ID = "SET_TIMER_CUSTOM_APP_ID";
export const SAVE_SESSION_AND_CLEAR_TIMER = "SAVE_SESSION_AND_CLEAR_TIMER";
export const SET_TOTAL_TIME = "SET_TOTAL_TIME";
export const SET_CURRENT_SESSION = "SET_CURRENT_SESSION";
export const SET_TIMER_RUNNING = "SET_TIMER_RUNNING";
export const UPDATE = "UPDATE";
export const SET_AND_START_TIMER = "SET_AND_START_TIMER";
export const REQUEST_FAILED = "REQUEST_FAILED";

export const clearTimer = () => ({
  type: CLEAR_TIMER,
});

export const setTimerUserId = (uesrId) => ({
  type: SET_TIMER_USER_ID,
  uesrId,
});

export const setTimerRunning = (timerRunning) => ({
  type: SET_TIMER_RUNNING,
  timerRunning,
});

export const setTimerCustomAppId = (customAppId) => ({
  type: SET_TIMER_CUSTOM_APP_ID,
  customAppId,
});

export const setTotalTime = (totalTime) => ({
  type: SET_TOTAL_TIME,
  totalTime,
});

export const setCurrentSession = (currentSession) => ({
  type: SET_CURRENT_SESSION,
  currentSession,
});

export const updateTimer = (deltaTime) => ({
  type: UPDATE,
  deltaTime,
});

export const setAndStartTimer = (
  userId,
  customAppId,
  totalTime,
  shouldTrackTimeInChart
) => ({
  type: SET_AND_START_TIMER,
  timerRunning: true,
  userId,
  customAppId,
  totalTime,
  currentSession: 0,
  shouldTrackTimeInChart,
});

export const requestFailed = (message) => ({
  type: REQUEST_FAILED,
  message,
});

export const requestLoadAppTimer =
  (userId, customAppId) => async (dispatch) => {
    try {
      const response = await UserActivityService().getTotalTimeInAppThisMonth(
        userId,
        customAppId
      );

      if (response.shouldTrackTimeInChart) {
        //convert totalTimeInSeconds to milliseconds and then start timer
        const milliseconds = response.totalTimeInSeconds * 1000;
        dispatch(
          setAndStartTimer(
            userId,
            customAppId,
            milliseconds,
            response.shouldTrackTimeInChart
          )
        );
      }
    } catch (error) {
      console.error("Unable to get total time in app:", error);
      dispatch(requestFailed("Internal error!"));
    }
  };

export const saveSessionAndClearTimer =
  (userId, customAppId, currentSession) => async (dispatch) => {
    try {
      dispatch(setTimerRunning(false));

      const secondsInSession = Math.floor(currentSession / 1000);
      //Make call
      const response = await UserActivityService().logChartingInteraction(
        userId,
        customAppId,
        secondsInSession
      );

      dispatch(clearTimer());
    } catch (error) {
      console.error("Unable to get total time in app:", error);
      dispatch(requestFailed("Internal error!"));
    }
  };



// WEBPACK FOOTER //
// ./src/actions/userActivity.js